<div class="account-balance-card">
  @if (!hasData) {
    <div class="u-flex-center">
      <mat-spinner color="primary" diameter="50"></mat-spinner>
    </div>
  }
  @if (hasData) {
    <div class="account-balance-card_content" (click)="navigateTo('billing')">
      <div class="account-balance-card_status {{ cardStatus }}"></div>
      <div class="account-balance-card_balance">
        <p class="mat-body-medium u-text-no-margin">
          &pound; {{ accountDetails ? accountDetails.accountBalance : "0.00" }}
        </p>
        <p class="mat-body-medium u-text-no-margin account-status">
          {{
          accountDetails ? accountDetails.accountStatus : "No balance found"
          }}
        </p>
      </div>
    </div>
    @if (!accountDetails.directDebitEnabled) {
      <div class="account-balance-card_button">
        @if (fetchingDirectDebitLink) {
          <div class="u-flex-center">
            <mat-spinner color="primary" diameter="50"></mat-spinner>
          </div>
        }
        @if (!fetchingDirectDebitLink) {
          <button mat-button class="flat-button_round warn" (click)="setupDirectDebit()"
            [disabled]="!userActive">
            <span>Enable direct debit</span>
          </button>
        }
      </div>
    }
    @if (!fetchingDirectDebitLink) {
      <mat-icon svgIcon="chevron_right" (click)="setupDirectDebit()"></mat-icon>
    }
  }
</div>